



















































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import store from "@/store";
//  @utilities
import { Chart } from "highcharts-vue";
import Highcharts from "highcharts";
import moment from "moment";
import _ from "underscore";
//  @types
import { ExtendedVessel } from "@/types/vessel";
import { SpeedLossStatistic } from "@/types/SpeedLossStatistic";
import { DiagnosticsChartConfig } from "@/types/DiagnosticsChartConfig";
//  @components
import DateRangeEventsDatepicker from "@/components/diagnostics/DateRangeEventsDatepicker.vue";

//  @modules
import { getModule } from "vuex-module-decorators";
import DiagnosticsModule from "@/store/clients/Diagnostics.module";
import VesselsModule from "@/store/clients/Vessels.module";

const Diagnostics = getModule(DiagnosticsModule, store);
const Vessels = getModule(VesselsModule, store);

@Component({
  components: {
    Highcharts: Chart,
    DateRangeEventsDatepicker,
  },
})
export default class ChangeInShaftPowerCard extends Vue {
  chart!: any;
  chartLoaded = false;
  isFirstPeriodFromDateModalActive = false;
  isFirstPeriodToDateModalActive = false;
  isSecondPeriodFromDateModalActive = false;
  isSecondPeriodToDateModalActive = false;
  isToDateModalActive = false;
  isDataLoading = false;
  filterMenu = false;
  filterMenuModal = false;

  // Use safe defaults here — populate real values in created()
  speed: number[] = [0, 25];
  granularity = "Auto";
  condition = "Laden";

  currentDate: string = moment.utc().format("YYYY-MM-DD");
  firstPeriodFromDate: string = moment.utc().subtract(7, "day").format("YYYY-MM-DD");
  firstPeriodToDate: string = moment.utc().format("YYYY-MM-DD");
  firstPeriodData: number[][] = [];
  filtredFirstPeriodData: number[][] = [];
  secondPeriodFromDate: string = moment.utc().subtract(14, "day").format("YYYY-MM-DD");
  secondPeriodToDate: string = moment.utc().format("YYYY-MM-DD");
  secondPeriodData: number[][] = [];
  filtredSecondPeriodData: number[][] = [];
  conditionsList: { text: string }[] = [
    {
      text: "Laden",
    },
    {
      text: "Ballast",
    },
  ];
  intervalList: { text: string; value: string; hint?: string; disabledHint?: string }[] = [
    {
      text: "Auto",
      value: "Auto",
      hint: "Lowest available granularity for selected range",
    },
    {
      text: "Day",
      value: "Day",
      hint: "One point per day (average)",
    },
    {
      text: "Hour",
      value: "Hour",
      disabledHint: "Filter unavailable: date range exceeds 6 months",
    },
    {
      text: "Quarter-Hourly",
      value: "QuarterHour",
      hint: "One point per 15 minutes (average)",
      disabledHint: "Filter unavailable: date range exceeds 15 days",
    },
    {
      text: "Minute",
      value: "Minute",
      hint: "One point per minute (average)",
      disabledHint: "Filter unavailable: date range exceeds 3 days",
    },
    {
      text: "Raw",
      value: "Raw",
      hint: "All recorded values",
      disabledHint: "Filter unavailable: date range exceeds 2 days",
    },
  ];
  intervalLimit: { [key: string]: number } = {
    Raw: this.daysToMinutes(1),
    Minute: this.daysToMinutes(2),
    QuarterHour: this.daysToMinutes(14),
    Hour: this.daysToMinutes(90),
  };
  speedRange: { text: string } = {
    text: "Speed Range",
  };

  // @Getters

  get firstPeriodDateRange(): [string, string] {
    return [this.firstPeriodFromDate, this.firstPeriodToDate];
  }
  set firstPeriodDateRange(val: [string, string]) {
    this.firstPeriodFromDate = val[0];
    this.firstPeriodToDate = val[1];
  }

  get secondPeriodDateRange(): [string, string] {
    return [this.secondPeriodFromDate, this.secondPeriodToDate];
  }
  set secondPeriodDateRange(val: [string, string]) {
    this.secondPeriodFromDate = val[0];
    this.secondPeriodToDate = val[1];
  }

  get vessel(): ExtendedVessel | null {
    if (!Vessels.currentVessel) return null;
    return Vessels.currentVessel;
  }

  get vesselLogDataMinDate(): string {
    if (!Vessels.currentVessel) return "2000-01-01";
    return Vessels.currentVessel.logDataMinDate;
  }

  get hasDraftConditionRanges(): boolean {
    if ((this.vessel?.ballastDraftHigh || this.vessel?.ballastDraftLow || this.vessel?.ladenDraftHigh || this.vessel?.ladenDraftLow) == null) return false;
    else return true;
  }

  get autoGranularity(): string {
    const firstPeriodSelectedTimeInMinutes = this.minutesDiff(new Date(this.firstPeriodFromDate), new Date(this.firstPeriodToDate));
    const secondPeriodSelectedTimeInMinutes = this.minutesDiff(new Date(this.secondPeriodFromDate), new Date(this.secondPeriodToDate));
    const selectedTimeInMinutes = Math.max(firstPeriodSelectedTimeInMinutes, secondPeriodSelectedTimeInMinutes);
    if (selectedTimeInMinutes <= 1440) {
      return "Raw";
    } else if (selectedTimeInMinutes <= 2880) {
      return "Minute";
    } else if (selectedTimeInMinutes <= 20160) {
      return "QuarterHour";
    } else if (selectedTimeInMinutes <= 129600) {
      return "Hour";
    }

    return "Day";
  }

  get averageKPI(): string {
    if (!this.filtredFirstPeriodData.length || !this.filtredSecondPeriodData.length) return "";
    const secondPeriodMap = new Map();
    for (const [speed, power] of this.filtredSecondPeriodData) {
      const roundedSpeed = Math.round(speed);
      secondPeriodMap.set(roundedSpeed, power);
    }
    const diffs = [];
    for (const [speed, power1] of this.filtredFirstPeriodData) {
      const roundedSpeed1 = Math.round(speed);
      if (secondPeriodMap.has(roundedSpeed1)) {
        const power2 = secondPeriodMap.get(roundedSpeed1);
        const diff = power2 / power1;
        diffs.push(diff);
      }
    }
    if (diffs.length === 0) return "";
    const averageDiff = diffs.reduce((sum, value) => sum + value, 0) / diffs.length;
    const averageDiffPercentage = (averageDiff - 1) * 100;
    return averageDiffPercentage.toFixed(1);
  }

  get averageKPIInfo(): { value: string; type: "increase" | "decrease" | "none"; icon: string } {
    const kpi = Number(this.averageKPI);
    if (this.averageKPI === "" || isNaN(kpi)) {
      return { value: "", type: "none", icon: "" };
    }
    if (kpi > 0) {
      return { value: Math.abs(kpi).toFixed(1), type: "increase", icon: "$ArrowUpCircle" };
    } else if (kpi < 0) {
      return { value: Math.abs(kpi).toFixed(1), type: "decrease", icon: "$ArrowDownCircle" };
    } else {
      return { value: "0.0", type: "none", icon: "" };
    }
  }

  get diagnosticsConfig(): DiagnosticsChartConfig {
    return Diagnostics.diagnosticsChartConfig;
  }

  get stwLegend(): string {
    return this.diagnosticsConfig.useDerivedStw ? "Derived STW (knots)" : "Speed Log (knots)";
  }

  get ChartOptions(): any {
    if (!this.chartLoaded || !Highcharts) return {};
    const ctx = this;
    const options = {
      chart: ctx.chartSettings,
      height: "100%",
      title: { text: "" },
      legend: {
        itemStyle: {
          fontSize: "14px",
          color: this.themeColor("ContentTertiary"),
          fontWeight: "400",
        },
        itemHoverStyle: {
          color: this.themeColor("ContentInverseTertiary"),
        },
      },
      yAxis: {
        min: 0,
        max: 30000,
        title: {
          text: "Shaft Power (kW)",
          style: { color: this.themeColor("ContentTertiary") },
        },
        labels: {
          formatter: function () {
            const $this: any = this;
            if ($this.value >= 1000) return Highcharts.numberFormat($this.value / 1000, 0) + "k"; // Format with 0 decimals place + 'k'
            return $this.value; // Return original value for numbers less than 1000
          },
          style: { color: this.themeColor("ContentPrimary") },
        },
        gridLineColor: this.themeColor("ContentInverseSecondary"),
        lineColor: this.themeColor("ContentInverseSecondary"),
      },
      xAxis: {
        min: 0,
        max: 25,
        minorTickLength: 0,
        tickLength: 0,
        labels: {
          format: "{value}",
          style: { color: this.themeColor("ContentPrimary") },
        },
        title: {
          text: this.stwLegend,
          style: { color: this.themeColor("ContentTertiary") },
        },
        lineColor: this.themeColor("ContentInverseSecondary"),
      },
      plotOptions: {
        area: {
          threshold: 0,
          marker: {
            enabled: false,
          },
        },
        series: {
          showInLegend: true,
          dataLabels: { enabled: false },
        },
      },
      tooltip: {
        formatter: function () {
          const $this: any = this;
          const dateSpan = $this.point.date ? `<span>Date: <b>${moment.utc($this.point.date).format("DD. MMM, YYYY HH:mm")}</b></span><br>` : "";
          return `${dateSpan}<span>Shaft Power: <b>${Number($this.point.y.toFixed(2))} kW</b></span><br><span>STW: <b style="margin-bottom: 5px;">${$this.point.x.toFixed(1)} knots</b></span>`;
        },
        backgroundColor: this.themeColor("BackgroundTooltip"),
        borderWidth: 0,
        borderRadius: 16,
        padding: 12,
        shadow: false,
        style: {
          color: "#EBEBEB",
        },
      },
      series: this.seriesData,
      credits: { enabled: false },
      exporting: { enabled: false },
    };

    return options;
  }

  get chartSettings(): any {
    if (!this.chartLoaded) return {};
    const ctx = this;
    return {
      zoomType: "x",
      spacingTop: 30,
      spacingBottom: 0,
      spacingLeft: 0,
      spacingRight: 0,
      style: { fontFamily: "Helvetica Neue" },
      backgroundColor: this.themeColor("BackgroundPrimaryDefault"),
      events: {
        selection: function (event: any) {
          //  trigger onChartZoom event on zoom
          ctx.$emit("onEventChartZoom", event);
        },
      },
    };
  }

  get theoreticalCurve(): number[][] {
    if (_.isEmpty(Diagnostics.propulsionCurve)) return [];
    const xValues = Diagnostics.propulsionCurve.xValues;
    const yValues = Diagnostics.propulsionCurve.yValues;

    const series: number[][] = [];

    yValues.forEach((v, i) => series.push([xValues[i], v]));

    return series;
  }

  get benchmarkCurve(): number[][] {
    if (_.isEmpty(Diagnostics.propulsionCurve) || this.latestSpeedLossStatistics == null || this.latestSpeedLossStatistics.benchmark.level === 0) return [];
    const xValues = Diagnostics.propulsionCurve.xValues;
    const yValues = Diagnostics.propulsionCurve.yValues;

    const series: number[][] = [];
    const benchmarkPercentFactor = 1 + this.latestSpeedLossStatistics!.benchmark.level / 100;
    yValues.forEach((v, i) => series.push([xValues[i] * benchmarkPercentFactor, v]));

    return series;
  }

  get latestSpeedLossStatistics(): SpeedLossStatistic | null {
    return Diagnostics.speedLossStatistics[Diagnostics.speedLossStatistics.length - 1] ?? null;
  }

  get seriesData(): any {
    // bugfix < >
    if (this.chart.series.length) {
      /* IMPORTANT: There is also a bug in Highcharts when it has more than 2 series and they are updated dynamically it "loses" correct indexes of the series and displays data in a weird manner so the solution is to clear the series array before it will be updated */
      while (this.chart.series.length) {
        this.chart.series[0].remove();
      }
    }
    // bugfix </>
    const scatterPointsSerie = {
      name: "Period 1",
      type: "scatter",
      keys: ["x", "y", "date"],
      data: this.filtredFirstPeriodData,
      stickyTracking: false,
      /* IMPORTANT:  https://www.highcharts.com/forum/viewtopic.php?f=9&t=44589 Turns out scatter points have a bug. When they get updated they can be displayed as line-through-dots with property lineWidth: 2 so here we need to set the lineWidth: 0, otherwise it should be set always through chart.series.forEach loop in serie.options.lineWidth*/
      lineWidth: 0,
      color: this.themeColor("BorderBrandPrimarySubtle"),
      marker: {
        radius: 2.5,
        symbol: "circle",
        color: this.themeColor("BorderBrandPrimarySubtle"),
      },
    };

    const scatterPointsSerie2 = {
      name: "Period 2",
      type: "scatter",
      keys: ["x", "y", "date"],
      data: this.filtredSecondPeriodData,
      stickyTracking: false,
      color: this.themeColor("BackgroundBrandSecondary"),
      /* IMPORTANT: https://www.highcharts.com/forum/viewtopic.php?f=9&t=44589 Turns out scatter points have a bug. When they get updated they can be displayed as line-through-dots with property lineWidth: 2 so here we need to set the lineWidth: 0, otherwise it should be set always through chart.series.forEach loop in serie.options.lineWidth */
      lineWidth: 0,
      marker: {
        radius: 2.5,
        symbol: "circle",
        color: this.themeColor("BackgroundBrandSecondary"),
      },
    };

    const benchmarkLine = {
      name: "Benchmark",
      type: "spline",
      data: this.benchmarkCurve,
      stickyTracking: false,
      lineWidth: 2,
      dashStyle: "ShortDot",
      color: this.themeColor("BackgroundInfoPrimary"),
      marker: {
        enabled: false,
        radius: 2.5,
        symbol: "circle",
        color: this.themeColor("BackgroundInfoPrimary"),
      },
    };

    const theoreticalLine = {
      name: "Baseline",
      type: "spline",
      data: this.theoreticalCurve,
      stickyTracking: false,
      lineWidth: 2,
      dashStyle: "ShortDot",
      color: this.themeColor("ContentInverseTertiary"),
      marker: {
        enabled: false,
        radius: 2.5,
        symbol: "circle",
        color: this.themeColor("ContentInverseTertiary"),
      },
    };

    const series = [scatterPointsSerie, scatterPointsSerie2, benchmarkLine, theoreticalLine];

    return series;
  }

  get propulsionEfficiencyToolTooltipText(): string {
    return "Compares speed and power between two periods to assess if increased power aligns with speed loss; not included in the calculations in the Speed Loss chart above";
  }

  get avgChangeShaftPowerTooltipText(): string {
    return "Average change in Shaft Power";
  }

  get isNautilusVessel(): boolean {
    return this.vessel?.onboardSystem === "Nautilus";
  }

  //  @Methods
  chartReady(chart: any): void {
    this.chart = chart;
    this.chart.update(this.ChartOptions, true);
    this.chartLoaded = true;
  }

  daysToMinutes(days: number): number {
    return days * 24 * 60;
  }

  isDataIntervalAllowedForDataSize(value: string): boolean {
    if (!this.intervalLimit[value]) return true;
    return (
      moment.duration(moment.utc(this.firstPeriodToDate).diff(this.firstPeriodFromDate)).asMinutes() <= this.intervalLimit[value] &&
      moment.duration(moment.utc(this.secondPeriodToDate).diff(this.secondPeriodFromDate)).asMinutes() <= this.intervalLimit[value]
    );
  }

  async onPeriodDateRangeChange([from, to]: [string, string], period: 1 | 2) {
    if (period === 1) {
      this.firstPeriodFromDate = from;
      this.firstPeriodToDate = to;
      this.diagnosticsConfig.pePeriodOneFromDate = from;
      this.diagnosticsConfig.pePeriodOneToDate = to;
    } else {
      this.secondPeriodFromDate = from;
      this.secondPeriodToDate = to;
      this.diagnosticsConfig.pePeriodTwoFromDate = from;
      this.diagnosticsConfig.pePeriodTwoToDate = to;
    }

    this.isDataLoading = true;

    try {
      await Diagnostics.updateDiagnosticsChartConfig(this.diagnosticsConfig);

      if (period === 1) {
        const firstPeriodResponse = await Diagnostics.fetchPropulsionEfficency({
          vesselId: this.vessel!.id,
          fromDate: from,
          toDate: to,
          condition: this.diagnosticsConfig.peCondition,
          granularity: this.diagnosticsConfig.peGranularity === "Auto" ? this.autoGranularity : this.diagnosticsConfig.peGranularity,
        });
        this.firstPeriodData = Object.keys(firstPeriodResponse).map(key => {
          return [...firstPeriodResponse[key].split(",").map((item: string) => Number(item.replace(/\(|\)/g, ""))), key];
        });
        this.filtredFirstPeriodData = this.firstPeriodData;
      } else {
        const secondPeriodResponse = await Diagnostics.fetchPropulsionEfficency({
          vesselId: this.vessel!.id,
          fromDate: from,
          toDate: to,
          condition: this.diagnosticsConfig.peCondition,
          granularity: this.diagnosticsConfig.peGranularity === "Auto" ? this.autoGranularity : this.diagnosticsConfig.peGranularity,
        });
        this.secondPeriodData = Object.keys(secondPeriodResponse).map(key => {
          return [...secondPeriodResponse[key].split(",").map((item: string) => Number(item.replace(/\(|\)/g, ""))), key];
        });
        this.filtredSecondPeriodData = this.secondPeriodData;
      }

      await Diagnostics.fetchPropulsionEfficencyCurve({ vesselId: this.vessel!.id, condition: this.diagnosticsConfig.peCondition });
      this.applySpeedFilter();
    } finally {
      this.isDataLoading = false;
    }
  }

  async applyFilter(): Promise<void> {
    this.filterMenu = false;
    this.filterMenuModal = false;
    this.diagnosticsConfig.peMinSpeed = this.speed[0];
    this.diagnosticsConfig.peMaxSpeed = this.speed[1];
    if (this.diagnosticsConfig.peCondition !== this.condition || this.diagnosticsConfig.peGranularity !== this.granularity) {
      this.diagnosticsConfig.peGranularity = this.granularity;
      this.diagnosticsConfig.peCondition = this.condition;
      await this.fetchData();
    } else {
      this.applySpeedFilter();
    }
    await Diagnostics.updateDiagnosticsChartConfig(this.diagnosticsConfig);
  }

  applySpeedFilter(): void {
    this.filtredFirstPeriodData = this.firstPeriodData.filter(item => item[0] >= this.diagnosticsConfig.peMinSpeed && item[0] <= this.diagnosticsConfig.peMaxSpeed);
    this.filtredSecondPeriodData = this.secondPeriodData.filter(item => item[0] >= this.diagnosticsConfig.peMinSpeed && item[0] <= this.diagnosticsConfig.peMaxSpeed);
  }

  async fetchData(): Promise<void> {
    if (!this.vessel || this.isDataLoading) return;
    this.isDataLoading = true;
    try {
      const firstPeriodResponse = await Diagnostics.fetchPropulsionEfficency({
        vesselId: this.vessel.id,
        fromDate: this.firstPeriodFromDate,
        toDate: this.firstPeriodToDate,
        condition: this.diagnosticsConfig.peCondition,
        granularity: this.diagnosticsConfig.peGranularity === "Auto" ? this.autoGranularity : this.diagnosticsConfig.peGranularity,
      });
      this.firstPeriodData = Object.keys(firstPeriodResponse).map(key => {
        return [...firstPeriodResponse[key].split(",").map((item: string) => Number(item.replace(/\(|\)/g, ""))), key];
      });
      this.filtredFirstPeriodData = this.firstPeriodData;
      const secondPeriodResponse = await Diagnostics.fetchPropulsionEfficency({
        vesselId: this.vessel.id,
        fromDate: this.secondPeriodFromDate,
        toDate: this.secondPeriodToDate,
        condition: this.diagnosticsConfig.peCondition,
        granularity: this.diagnosticsConfig.peGranularity === "Auto" ? this.autoGranularity : this.diagnosticsConfig.peGranularity,
      });
      this.secondPeriodData = Object.keys(secondPeriodResponse).map(key => {
        return [...secondPeriodResponse[key].split(",").map((item: string) => Number(item.replace(/\(|\)/g, ""))), key];
      });
      this.filtredSecondPeriodData = this.secondPeriodData;
      this.applySpeedFilter();
      await Diagnostics.fetchPropulsionEfficencyCurve({ vesselId: this.vessel.id, condition: this.diagnosticsConfig.peCondition });
    } finally {
      this.isDataLoading = false;
    }
  }

  minutesDiff(fromDate: Date, toDate: Date): number {
    const diff = (fromDate.getTime() - toDate.getTime()) / 1000 / 60;

    return Math.abs(Math.round(diff));
  }

  closeFilterMenu(): void {
    this.filterMenu = false;
    this.filterMenuModal = false;
    this.speed = [this.diagnosticsConfig.peMinSpeed, this.diagnosticsConfig.peMaxSpeed];
    this.granularity = this.diagnosticsConfig.peGranularity;
    this.condition = this.diagnosticsConfig.peCondition;
  }

  themeColor(color: string): string {
    return (this.$vuetify.theme.themes[this.$vuetify.theme.dark ? "dark" : "light"][color] as any) ?? this.$vuetify.theme.themes.light[color];
  }

  async created(): Promise<void> {
    // initialize fields from diagnostics config if available (safe)
    const cfg: any = this.diagnosticsConfig ?? {};
    this.speed = [cfg.peMinSpeed ?? 0, cfg.peMaxSpeed ?? 25];
    this.granularity = cfg.peGranularity ?? "Auto";
    this.condition = cfg.peCondition ?? "Laden";
    this.firstPeriodFromDate = cfg.pePeriodOneFromDate ? moment.utc(cfg.pePeriodOneFromDate).format("YYYY-MM-DD") : this.firstPeriodFromDate;
    this.firstPeriodToDate = cfg.pePeriodOneToDate ? moment.utc(cfg.pePeriodOneToDate).format("YYYY-MM-DD") : this.firstPeriodToDate;
    this.secondPeriodFromDate = cfg.pePeriodTwoFromDate ? moment.utc(cfg.pePeriodTwoFromDate).format("YYYY-MM-DD") : this.secondPeriodFromDate;
    this.secondPeriodToDate = cfg.pePeriodTwoToDate ? moment.utc(cfg.pePeriodTwoToDate).format("YYYY-MM-DD") : this.secondPeriodToDate;

    await this.fetchData();
    this.$parent.$on("refetchPropulsionEfficiencyData", this.fetchData);
  }
}
